import { faCheck, faEye, faWarning } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Autocomplete, Box, Button, Pagination, Paper, TextField, Typography } from '@mui/material';
import { DataGrid, GridColDef, GridOverlay } from '@mui/x-data-grid';
import React, { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { Loader } from '../../components/loader/Loader';
import { fetchHistoryTableData } from '../../services/notificationService';
import './NotificationHistoryTable.css';
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider';

const historyTableSearchConfig = ["creationTime","creationTime","id"];
function NotificationHistoryTable() {
    const { translate } = usePortalTranslation();
    const CUR_COMPONENT_COMMON="commonPortal";
    const CUR_COMPONENT = "notification"
    const [historyTableRows,setHistoryTableRows] = useState<[]>([]);
    const [historyTablePageNumber,setHistoryTablePageNumber] = useState<number>(1);
    const [historyTableTotalPages,setHistoryTableTotalPages] = useState<number>(1);
    const [historySearchField,setHistorySearchField] = useState<string>("");
    const [historySearchTimerId,setHistoryTimerId] = useState<NodeJS.Timeout | null>(null);
    const [historyTableLoader,setHistoryTableLoader] = useState<boolean>(false);

    useEffect(() => {
      async function getHistoryTableData(){
        setHistoryTableLoader(true);
        const historyTableData = await fetchHistoryTableData(0);
        setHistoryTableRows(historyTableData.features);
        setHistoryTablePageNumber(historyTableData.currentPage+1);
        setHistoryTableTotalPages(historyTableData.totalPage);
        setHistoryTableLoader(false);
      }
      getHistoryTableData();
    },[])
    const historyTableColumns: GridColDef[] = [
        {
          field: "id",
          headerName:translate(TranslationEnum.notification,"Reference Id"),
          minWidth: 300,
          flex: 3,
          sortable: false,
          disableColumnMenu: true
        },
        {
          field: "creationTime",
          headerName:translate(TranslationEnum.notification,"Created On"),
          minWidth: 150,
          flex: 2,
          sortable: false,
          disableColumnMenu: true
        },
        {
          field: "statusIcon",
          headerName:translate(TranslationEnum.notification,"Status"),
          minWidth: 150,
          flex: 1,
          sortable: false,
          disableColumnMenu: true,
          align: "center",
          headerAlign: "center",
          renderCell: (params) => {
            const wasSuccess = params.row.status==='Success';
            return <>
              {wasSuccess?
                  <FontAwesomeIcon icon={faCheck} color="mediumseagreen" fontSize="20px" />:
                  <FontAwesomeIcon icon={faWarning} color="indianred" fontSize="20px" />}
            </>
            
          }
        },
        // {
        //   field: "viewResponse",
        //   headerName: "View Response",
        //   minWidth: 180,
        //   flex: 1,
        //   sortable: false,
        //   disableColumnMenu: true,
        //   align: "center",
        //   headerAlign: "center",
        //   renderCell: (params) => {
        //     return <FontAwesomeIcon icon={faEye} fontSize="20px" />
        //   }
        // },
    ]
    
    const debouncingHistoryTableSearch = useCallback(
      (value: string) => {
        if(historySearchTimerId){
          clearTimeout(historySearchTimerId);
        }else{
          const newTimerId = setTimeout(async () => {
            setHistoryTableLoader(true);
            setHistoryTablePageNumber(1);
            const historyTableData = await fetchHistoryTableData(0,value,historyTableSearchConfig);
            setHistoryTableRows(historyTableData.features);
            setHistoryTableTotalPages(historyTableData.totalPage);
            setHistoryTableLoader(false);
          },400);
          setHistoryTimerId(historySearchTimerId);
        }
      },[historySearchField,historySearchTimerId]
)
    const handleHistoryPagination = async (event:ChangeEvent<unknown>,value:number) => {
      setHistoryTableLoader(true);
      const historyTableData = await fetchHistoryTableData(value-1,historySearchField,historyTableSearchConfig);
      setHistoryTableRows(historyTableData.features);
      setHistoryTablePageNumber(value);
      setHistoryTableLoader(false);
    }
    const handleHistorySearch = async (event:ChangeEvent<HTMLInputElement>) => {
        setHistorySearchField(event.target.value);
        debouncingHistoryTableSearch(event.target.value);
    }
    const customNoRowsOverlay = () => (
      <GridOverlay>
        <div>{translate(TranslationEnum.common_portal,"No Rows")}</div>
      </GridOverlay>
    );
  return (
    <Paper className="notificationsPaperContainer">
      <Box className="notificationsHistoryTableBoxContainer">
        <div className='notificationsBoxBarContainer'>
          <div className='notficationsBoxHeadingContainer'>
            <Typography className='notificationsBoxHeading' variant="h6" pl={2} >{translate(TranslationEnum.notification,"History Table")}</Typography> 
          </div>
          <TextField className="notficationsHistoryTableSearch" onChange={handleHistorySearch} size="small" id="historySearch" label={translate(TranslationEnum.common_portal,"Search")} variant="outlined" />
        </div> 
        {historyTableLoader?
        <Loader />:
        <>
            <DataGrid
                className="notificationsHistoryTable"
                rows={historyTableRows}
                columns={historyTableColumns}
                disableRowSelectionOnClick
                hideFooter 
                components={{
                  NoRowsOverlay: customNoRowsOverlay
                }}
            />
          <Pagination onChange={handleHistoryPagination} className="notificationsPagination" page={historyTablePageNumber} count={historyTableTotalPages} size="small" variant='outlined' shape='rounded' />
        </>} 
        
      </Box>
    </Paper>
   
  )
}

export default NotificationHistoryTable;